import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { CollectionsService } from '../../../collections/service/collections.service';
import { CartItem } from '../../interfaces/cart.interface';
import { CartService } from '../../services/cart.service';
import {
  RemoveCartItem,
  UpdateCartItem,
} from '../../store/actions/cart.actions';
import { NavigationEnd, Router } from '@angular/router';
import { NativeIntegrationService } from '../../../../core/services/native-integration.service';

@Component({
  selector: 'app-product-edit',
  templateUrl: './product-edit.component.html',
  styleUrls: ['./product-edit.component.scss'],
})
export class ProductEditComponent implements OnInit {
  editProductOpen = false;
  @Input() cartItem: CartItem | undefined;
  quantity = 1;
  timerRunning = false;
  private subscriptions: Subscription = new Subscription();

  constructor(
    public collectionsService: CollectionsService,
    private store: Store<{ cart: CartItem[] }>,
    public cartService: CartService,
    private nis: NativeIntegrationService
  ) {}

  ngOnInit(): void {
    const cartOpenSub = this.cartService.cartOpen$.subscribe();
    this.subscriptions.add(cartOpenSub);
    if (this.cartItem) {
      this.quantity = this.cartItem.quantity;
    }
  }

  remove(cartItem: CartItem): void {
    this.nis.vibrate();
    this.store.dispatch(RemoveCartItem(cartItem));
  }

  editProduct(): void {
    this.nis.hapticFeedbackClick();
    this.editProductOpen = !this.editProductOpen;
  }

  closeCart(): void {
    this.nis.hapticFeedbackClick();

    this.cartService.cartOpen$.next(false);
  }

  quantityUp(): void {
    this.nis.hapticFeedbackClick();

    this.quantity += 1;
    if (!this.timerRunning) {
      this.timerRunning = true;
      setTimeout(() => {
        this.timerRunning = false;
        this.updateQuantity(this.quantity);
      }, 1500);
    }
  }

  quantityDown(): void {
    this.nis.hapticFeedbackClick();

    if (this.quantity > 1) {
      this.quantity -= 1;
      if (!this.timerRunning) {
        this.timerRunning = true;
        setTimeout(() => {
          this.timerRunning = false;
          this.updateQuantity(this.quantity);
        }, 3500);
      }
    }
  }

  updateQuantity(quantity: number): void {
    this.nis.vibrate();
    if (this.cartItem) {
      const updatedCartItem = {
        ...this.cartItem,
        quantity: this.quantity,
      } as CartItem;
      const didAddProduct = this.quantity > this.cartItem.quantity;
      this.store.dispatch(
        UpdateCartItem({ item: updatedCartItem, didAddProduct })
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
